import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

const Link = (props) => {
    const { offerName, affiliateName } = useParams();

    const getSearch = () => new URLSearchParams(props.history.location.search).toString();

    if (affiliateName) {
        return <>{props.value}</>;
    }
    else if (offerName) {
        return (
            <RouterLink to={`/reports/conversion/${offerName}/${props.value}/?${getSearch()}`}>
                {props.value}
            </RouterLink>
        );
    }
    else {
        return <RouterLink to={`/reports/conversion/${props.value}/?${getSearch()}`}>{props.value}</RouterLink>;
    }
};

Link.propTypes = {
    value: PropTypes.string.isRequired,
};

let Component = Link;
Component = withRouter(Component);

export default Component;
